module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_70-051a82071e1208869f4a07718eed64cb.png";